import React from "react"
import { Container } from "./mappedin-layers.featurelist.style"

const LayerFeatureList = ({
  logoSrc,
  logoAlt,
  title,
  description,
  color,
  children,
}) => {
  return (
    <Container titleColor={color}>
      <img src={logoSrc} alt={logoAlt} />
      <h3>{title}</h3>
      <p>{description}</p>
      <ul>{children}</ul>
    </Container>
  )
}

export default LayerFeatureList
